import { createContext } from "react";

export const EditEmployeeOneContext  = createContext(null);